module.exports = __webpack_public_path__ + "static/logo-reto-zapopan-cddd1a63b2e59a33c44aab41182383e9.svg";